module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-loader></app-loader>\n<router-outlet></router-outlet>\n"